export default {
  get_conf: '/conf/api/get',
  get_conf_object_for_editing: '/conf/api/get-object-for-editing',
  get_conf_categories: '/conf/api/get-categories',
  conf_reload_default: '/conf/load-default',
};
